<template>
  <div id="app">
    <router-view></router-view>
    <WhatsappFloat v-if="shouldShowWhatsApp" />
  </div>
</template>

<script>
import WhatsappFloat from "./components/WhatsappFloat.vue";

export default {
  components: {
    WhatsappFloat
  },
  computed: {
    shouldShowWhatsApp() {
      return this.$route.meta && this.$route.meta.showWhatsApp === true;
    }
  },
  mounted() {
    window.$.validator.methods.email = function (value, element) {
      return (
        this.optional(element) ||
        /^([a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)@[a-zA-Z0-9]+(?:[.-]?[a-zA-Z0-9]+)\.[a-zA-Z]{2,7})$/.test(
          value
        )
      );
    };
  }
};
</script>

<style lang="scss">
body {
  background: #fff;
}
@import "assets/scss/main";
</style>
